import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { IonicModule } from '@ionic/angular';

import { ChargeActionSheetPage } from './charge-action-sheet.page';
import { TranslateModule } from '@ngx-translate/core';

@NgModule({
  imports: [CommonModule, FormsModule, TranslateModule, IonicModule],
  declarations: [ChargeActionSheetPage],
  exports: [TranslateModule], // Added TranslateModule here
})
export class ChargeActionSheetPageModule {}
